/**
 * ReferralSidebarCard.js — красная promo-карточка в desktop-sidebar.
 *
 * Где: NavMenu footer, между основными пунктами и «Поддержка / Выйти».
 * На телефоне не показывается — там рефералка остаётся в «Управлять».
 *
 * Клик «Пригласить» → NavBar открывает ModalHowReferalWorks.
 * Картинка: public/images/referral/referral-gift-box.png (прозрачный PNG).
 */

import { useState } from "react";
import { color_red_default, color_white } from "../../../constants/colors";
import { useWindowDimensions } from "../../../utils";
import {
  OnestNormalSmall,
  OnestSemiBoldDefault,
} from "../../styled/TextComponents";
import { useI18n } from "../../../i18n/I18nProvider";

const GIFT_IMG = `${process.env.PUBLIC_URL}/images/referral/referral-gift-box.png`;

const ReferralSidebarCard = ({ onInviteClick }) => {
  const { t } = useI18n();
  const { height: screenHeight } = useWindowDimensions();
  const compact = screenHeight < 660;
  const [btnHovered, setBtnHovered] = useState(false);
  const [btnPressed, setBtnPressed] = useState(false);

  const giftSize = 80;

  return (
    <div
      style={{
        position: "relative",
        width: 208,
        marginTop: compact ? 8 : 12,
        marginBottom: compact ? 8 : 12,
        marginLeft: "auto",
        marginRight: "auto",
        padding: compact ? "14px 14px 12px" : "16px 16px 14px",
        boxSizing: "border-box",
        borderRadius: 16,
        backgroundColor: color_red_default,
        overflow: "visible",
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
      }}
    >
      <OnestSemiBoldDefault
        style={{
          color: color_white,
          fontSize: compact ? 15 : 16,
          lineHeight: 1.25,
          textAlign: "left",
          width: "100%",
        }}
      >
        {t("Приведи коллегу")}
      </OnestSemiBoldDefault>

      <div style={{ marginTop: 6 }}>
        <img
          src={GIFT_IMG}
          alt=""
          style={{
            float: "right",
            width: giftSize,
            height: giftSize,
            objectFit: "contain",
            marginLeft: 6,
            marginBottom: 0,
            pointerEvents: "none",
            userSelect: "none",
            position: "relative",
            zIndex: 2,
          }}
        />

        <OnestNormalSmall
          style={{
            color: color_white,
            fontSize: compact ? 11 : 12,
            lineHeight: 1.35,
            fontWeight: 400,
            textAlign: "left",
          }}
        >
          {t("+1 месяц подписки")}
        </OnestNormalSmall>
        <OnestNormalSmall
          style={{
            color: color_white,
            fontSize: compact ? 11 : 12,
            lineHeight: 1.35,
            marginTop: 2,
            fontWeight: 400,
            textAlign: "left",
          }}
        >
          {t("бесплатно")}
        </OnestNormalSmall>

        <button
          type="button"
          onClick={onInviteClick}
          onMouseEnter={() => setBtnHovered(true)}
          onMouseLeave={() => {
            setBtnHovered(false);
            setBtnPressed(false);
          }}
          onMouseDown={() => setBtnPressed(true)}
          onMouseUp={() => setBtnPressed(false)}
          style={{
            display: "block",
            width: "100%",
            marginTop: compact ? 12 : 16,
            padding: compact ? "8px 12px" : "10px 14px",
            border: "none",
            borderRadius: 20,
            backgroundColor: btnHovered ? "#f5f5f5" : color_white,
            color: color_red_default,
            fontFamily: "Onest, sans-serif",
            fontWeight: 600,
            fontSize: compact ? 13 : 14,
            cursor: "pointer",
            position: "relative",
            zIndex: 1,
            clear: "both",
            transition: "transform 0.15s ease, background-color 0.15s ease",
            transform: btnPressed
              ? "scale(0.98)"
              : btnHovered
                ? "scale(1.02)"
                : "scale(1)",
          }}
        >
          {t("Пригласить")}
        </button>
      </div>
    </div>
  );
};

export default ReferralSidebarCard;
